import React, { useState, useEffect, useRef } from 'react';
import './AITagging.css';
import vectorimg1 from '../../assets/images/vectorimg1.svg';
import vectorimg2 from '../../assets/images/vectorimg2.svg';
import vectorimg3 from '../../assets/images/vectoimg3.svg';

const AITagging = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Optional: Stop observing after animation triggers
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.3, // Trigger when 30% of the element is visible
        rootMargin: '0px 0px -50px 0px' // Trigger slightly before element is fully in view
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
   
        <div className={`ai-tagging-container ${isVisible ? 'animate' : ''}`} ref={containerRef}>
        <div className='ai-tagging-content'>
           
            <h1>
                <p className={`ai-tagging-title ${isVisible ? 'animate-zoom-in delay-300' : ''}`}>
                From Upload to Delivery,<br/> Made Effortless.                </p>
                <p className={`ai-tagging-subtitle ${isVisible ? 'animate-zoom-in delay-500' : ''}`}>
                From creation to collaboration to final delivery—track every step with clarity and control.                       </p>

            </h1>
          

                  </div>
         
          {/* Vector Images */}
          <div className="vector-container">
            <div className="vector-images">
            <img src={vectorimg1} alt="Vector Image 1" className="v1" />
            <img src={vectorimg2} alt="Vector Image 2" className="v2" />

            </div>
            <img src={vectorimg3} alt="Vector Image 3" className="v3" />
          </div>
          </div>
   
   
    
  );
};

export default AITagging;
